module.exports = __webpack_public_path__ + "img/profile_credential_013.70fc856d.png";